// NavigationProvider.js
import { useNavigate } from 'react-router-dom';
import { NavigationContext } from './NavigationContext';

export function NavigationProvider({ children }) {
  const navigate = useNavigate();
  return (
    <NavigationContext.Provider value={navigate}>
      {children}
    </NavigationContext.Provider>
  );
}
